import React, { useEffect, useRef, useState } from 'react';
import SideNavLayout from '../Sidenav/SideNavLayout';
import Bsshome from './BSSforms/Bsshome';
import SafetyhHome from './SafetyHealthforms/SafetyhHome';
import Weeklydrivehome from './WeeklyDforms/Weeklydrivehome';
import { FiFileText } from 'react-icons/fi'; // reuse the document icon
import { FiCamera } from 'react-icons/fi';
import api from '../api/api';
import noData from "../assets/si_alert-fill.svg"
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Backdrop, CircularProgress } from '@mui/material';
import ViewFormModal from './ViewFormModal';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DateModal from './Modals/DateModal';
import FilterModal from './Modals/FilterModal';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {
  calendericonblack,

} from "../utils/svgs/svgs";
import WDSFormModal from './WDSformModal';
import ViewSHPFormModal from './ViewSHPModal';
import AccidentInvestigation from './WeeklyDforms/accidentinvestigationform';
import TrailerHome from './TrailerForms/TrailerHome';
import ViewTrailerModal from './TrailerForms/ViewTrailerModal';
import { useLocation, useNavigate } from 'react-router-dom';
import AIFFormModal from './viewAiF';
import WDSMergeFormModal from './wdsmergemodal';
import ImageIcon from '@mui/icons-material/Image';
import dayjs from 'dayjs';
import minMax from "dayjs/plugin/minMax";
import ToastMessage from '../utils/muitoast';

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { useSelector } from 'react-redux';
import { OcrImageModal } from './viewocrimg';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(minMax);

const FormsDashboard = () => {
  // State to track the active form
  const [activeForm, setActiveForm] = useState(null);
   const [tableData,setTableData]=useState([]);
   const [deleteConfirm, setDeleteConfirm] = useState(null); // row pending delete
   const [loader,setLoader]=useState(false);
     const [severity, setSeverity] = useState('success');
     const [open, setOpen] = useState(false);
     const [alertMessage, setAlertMessage] = useState('');
   const [formView,setFormView]=useState(false);
   const [openImgModal, setOpenImgModal] = useState(false);
   const [rowData,setRowData]=useState([]);
   const [dateModalOpen, setDateModalOpen] = useState(false);
const [selectedDate, setSelectedDate] = useState(null);
 const [token, setToken] = useState(null);
const [formType,setFormType]=useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [showMergeBtn, setShowMergeBtn] = useState(false);
  const navigate=useNavigate()
     const [ocrimg,setOcrimg]=useState(null)
      const [loading, setLoading] = useState(false);
const [selectedFilters, setSelectedFilters] = useState({
  dates: [],
  employees: [],
  jobs: [],
  formTypes: [],
  statuses: [],
  methods:[],
  companyIds: []
});
 const { t, i18n } = useTranslation(['bbssafety', 'safetyhealth', 'weeklydriver']); 
   const userDetails = useSelector((state) => state.user.userDetails);
const [activeModal, setActiveModal] = useState(null);
const [filteredData, setFilteredData] = useState([]);
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
const [rowsPerPage, setRowsPerPage] = useState(10);
const [showPicker, setShowPicker] = useState(false);
const [searchTerm, setSearchTerm] = useState("");
const [showFilterPopup, setShowFilterPopup] = useState(false);
// Until the user explicitly picks a date range, fetches and search run across
// ALL data (no date params). The filters popup, search, and table therefore
// show everything. After the user applies/resets the picker, scoping kicks in.
const [dateRangeChanged, setDateRangeChanged] = useState(false);
const filterRef = useRef(null);
const [historyCalendar, setHistoryCalendar] = useState([
  {
    // startDate: dayjs().subtract(30, "day").toDate(),
    // endDate: dayjs().toDate(),
    startDate: dayjs().startOf('week').add(1, 'day').toDate(),
    endDate: dayjs().endOf('week').add(1, 'day').toDate(),
    key: "selection",
  },
]);

const pickerRef = useRef(null);

const [selectionRange, setSelectionRange] = useState([
  {
    // startDate: dayjs().subtract(30, "day").toDate(),
    // endDate: dayjs().toDate(),
    startDate: dayjs().startOf('week').add(1, 'day').toDate(),
    endDate: dayjs().endOf('week').toDate(),
    key: "selection",
  },
]);

  // Function to handle form change
  const handleFormClick = (formName) => {
    setActiveForm(formName);
  };
   const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const fetchTablesData = async (startDate, endDate) => {
    try {
  
      setLoader(true);
//     let params = {};

//     if (startDate && endDate) {
//       if (startDate === endDate) {
//         console.log("API Date:", startDate);
//         params.date = startDate;
//       } else {
//         console.log("API Date Range:", startDate, endDate);
//         params.start_date = startDate;
//         params.end_date = endDate;
//       }
//     }
// let response;
// if (userDetails.role === 3) {
//   response = await api.get(`/v1/forms/get`, {
//     params: { pm_id: userDetails.id }, // correct way to pass query params
//   });
// } else {
//   response = await api.get(`/v1/forms/get`);
// }

let params = {};

// ✅ Date handling
if (startDate && endDate) {
  if (startDate === endDate) {
    console.log("API Date:", startDate);
    params.start_date = startDate;   // 👈 backend expects start_date
  } else {
    console.log("API Date Range:", startDate, endDate);
    params.start_date = startDate;
    params.end_date = endDate;
  }
}

// ✅ Role-based param
if (userDetails.role === 3) {
  params.pm_id = userDetails.id;
}

// ✅ Single API call (dynamic params)
const response = await api.get(`/v1/forms/get`, { params });

      if (response.status === 200) {
        setTableData(response.data);
      }else{
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false); // Corrected
    }
  };
  // 🔎 Universal search — calls /v1/forms/search with current date range
  const searchForms = async (term) => {
    try {
      setLoader(true);
      const params = {};
      if (term && term.trim()) params.q = term.trim();

      // Only scope to the date range once the user has explicitly picked one.
      // Before that, search is universal.
      if (dateRangeChanged) {
        const start = dayjs(historyCalendar[0].startDate).format("YYYY-MM-DD");
        const end = dayjs(historyCalendar[0].endDate).format("YYYY-MM-DD");
        if (start && end) {
          params.start_date = start;
          params.end_date = end;
        }
      }
      if (userDetails?.role === 3) {
        params.pm_id = userDetails.id;
      }

      const response = await api.get(`/v1/forms/search`, { params });
      if (response.status === 200) {
        setTableData(response.data?.data || response.data || []);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error searching forms:", error);
      setTableData([]);
    } finally {
      setLoader(false);
    }
  };

  // Debounced search — only runs when user has typed something.
  // Empty string falls back to the standard date-range fetch.
  useEffect(() => {
    if (!userDetails) return;
    const handle = setTimeout(() => {
      if (searchTerm.trim() === "") {
        if (dateRangeChanged) {
          const start = dayjs(historyCalendar[0].startDate).format("YYYY-MM-DD");
          const end = dayjs(historyCalendar[0].endDate).format("YYYY-MM-DD");
          fetchTablesData(start, end);
        } else {
          fetchTablesData(); // universal
        }
      } else {
        searchForms(searchTerm);
      }
    }, 400);
    return () => clearTimeout(handle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      pickerRef.current &&
      !pickerRef.current.contains(event.target)
    ) {
      setShowPicker(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

useEffect(() => {
  const handleFilterClickOutside = (event) => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setShowFilterPopup(false);
    }
  };
  document.addEventListener("mousedown", handleFilterClickOutside);
  return () => document.removeEventListener("mousedown", handleFilterClickOutside);
}, []);

   useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get('allow');
 
    if (accessToken) {
      setToken(accessToken);
   
    }
  }, [location.search]);
useEffect(() => {
  if (!userDetails) return;
  // Default fetch: no date params — loads everything so the Filters popup,
  // search, and table show the full dataset. Scoping only happens once the
  // user picks a date range.
  fetchTablesData();
  i18n.changeLanguage("en");
}, [userDetails]);


  // useEffect(() => {
  //   // When tableData or selectedDate changes, filter
  //   if (selectedDate) {
  //     setFilteredData(tableData.filter(row => row.filled_date === selectedDate));
  //   } else {
  //     setFilteredData(tableData);
  //   }
  // }, [tableData, selectedDate]);

  useEffect(() => {
    const { dates, employees, jobs, formTypes, statuses, methods, companyIds } = selectedFilters;
  const filtered = tableData.filter(row => {
  const jsonDateObj = row.json_data?.find(obj => obj.Dates);
  const rowDate = jsonDateObj ? jsonDateObj.Dates : row.filled_date;

  const matchDate = dates.length === 0 || dates.includes(rowDate);
  const matchEmp = employees.length === 0 || employees.includes(`${row.emp_name} (${row.emp_id})`);
  const matchJob = jobs.length === 0 || jobs.includes(`${row.jobDescription} (${row.job_id})`);
  const matchForm = formTypes.length === 0 || formTypes.includes(row.form_type);
  const matchStatus = statuses.length === 0 || statuses.includes(getDisplayStatus(row));
  const matchMethod = methods.length === 0 || methods.includes(row.method);
  const matchCompany = companyIds.length === 0 || companyIds.includes(row.companyid);

  return matchDate && matchEmp && matchJob && matchForm && matchStatus && matchMethod && matchCompany;
});

    setFilteredData(filtered);
  }, [tableData, selectedFilters]);
  
const handleApply = () => {
  setHistoryCalendar(selectionRange);
  setShowPicker(false);
  setDateRangeChanged(true); // Now all fetches/search are scoped to this range.

  const start = dayjs(selectionRange[0].startDate).format("YYYY-MM-DD");
  const end = dayjs(selectionRange[0].endDate).format("YYYY-MM-DD");

  // 🔁 Trigger API refetch
  fetchTablesData(start, end);
};

const handleReset = () => {
  const defaultRange = [
    {
      startDate: dayjs().startOf('week').add(1, 'day').toDate(),
      endDate: dayjs().endOf('week').toDate(),
      key: "selection",
    },
  ];

  setSelectionRange(defaultRange);
  setHistoryCalendar(defaultRange);
  setShowPicker(false);
  // Reset drops date scoping — go back to the universal dataset.
  setDateRangeChanged(false);
  fetchTablesData();
};


  const handleSoftDelete = async (row) => {
    try {
      setLoader(true);
      const resp = await api.post(`/v1/forms/${row.id}/soft-delete`);
      if (resp.status === 200) {
        setSeverity('success');
        setAlertMessage('Form deleted successfully');
        setOpen(true);
        // Drop the row from the in-memory list
        setTableData((prev) => prev.filter((r) => r.id !== row.id));
      } else {
        setSeverity('error');
        setAlertMessage(resp?.message || 'Could not delete the form');
        setOpen(true);
      }
    } catch (e) {
      console.error('Soft delete error:', e);
      setSeverity('error');
      setAlertMessage('Something went wrong while deleting');
      setOpen(true);
    } finally {
      setLoader(false);
      setDeleteConfirm(null);
    }
  };

  const   handleViewForm = async (rowid,form_type) => {
    try {
      setLoader(true);
      const response = await api.get(`/v1/forms/get_by_id`,{
      params:{
          rowid:rowid
        }
      });
      if (response.status === 200) {
        setRowData(response.data[0]);
        setFormType(form_type)
        setFormView(true)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false); // Corrected
    }
  };

  const formTypeLabelMap = {
    BBS: 'BEHAVIOR BASED SAFETY (BBS) CARD',
    WDS: 'WEEKLY DRIVER LOG & SAFETY',
    SHP: 'SAFETY AND HEALTH PRIMARY AUDIT FORM',
    TRAILER: 'TRAILER INSPECTION FORM',
  };


  // Compute display status matching the table render logic
  const getDisplayStatus = (row) => {
    if (userDetails?.role === 3 && row.form_type === "SHP") {
      return row.pm_status === 'Y' ? 'Signed' : 'Pending';
    }
    if (!row.pm_sign && row.form_type === "SHP" && row.pm_status === "N") {
      return 'Pending';
    }
    return row.status === 'A' ? 'Completed' : 'Pending';
  };

  // Build company id → name map
  const [companyMap, setCompanyMap] = useState({});

  useEffect(() => {
    // First try to get names from API response (company_name field)
    const mapFromData = {};
    tableData.forEach(r => {
      if (r.companyid && r.company_name) mapFromData[r.companyid] = r.company_name;
    });

    // Find IDs that still need names
    const allIds = [...new Set(tableData.map(r => r.companyid).filter(Boolean))];
    const missingIds = allIds.filter(id => !mapFromData[id]);

    if (missingIds.length === 0) {
      setCompanyMap(mapFromData);
      return;
    }

    // Fetch missing company names
    const fetchNames = async () => {
      const fetched = { ...mapFromData };
      for (const id of missingIds) {
        try {
          const res = await api.get(`/v1/company/company_details`, { params: { qsearch: id } });
          if (res.status === 200 && res.data?.length > 0) {
            fetched[id] = res.data[0].name;
          }
        } catch (_) { /* skip */ }
      }
      setCompanyMap(fetched);
    };
    fetchNames();
  }, [tableData]);

  // Build unique filter options from current tableData
  const filterOptions = React.useMemo(() => {
    const formTypes = [...new Set(tableData.map(r => r.form_type).filter(Boolean))];
    const methods = [...new Set(tableData.map(r => r.method).filter(Boolean))];
    const displayStatuses = [...new Set(tableData.map(r => getDisplayStatus(r)))];
    const companyIds = [...new Set(tableData.map(r => r.companyid).filter(Boolean))];
    return { formTypes, methods, displayStatuses, companyIds };
  }, [tableData, userDetails]);

  const toggleFilter = (category, value) => {
    setSelectedFilters(prev => {
      const arr = prev[category];
      const updated = arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];
      return { ...prev, [category]: updated };
    });
  };

  const clearAllFilters = () => {
    setSelectedFilters({ dates: [], employees: [], jobs: [], formTypes: [], statuses: [], methods: [], companyIds: [] });
  };

  const activeFilterCount = selectedFilters.formTypes.length + selectedFilters.methods.length + selectedFilters.statuses.length + selectedFilters.companyIds.length;

const validateWDSSelection = (rows) => {
  if (!rows?.length) return false;

  // 1️⃣ All must be WDS
  if (!rows.every(r => r.form_type === "WDS")) return false;

  // 2️⃣ Same employee
  const empSet = new Set(rows.map(r => r.emp_id));
  if (empSet.size !== 1) return false;

  // 3️⃣ Dates must be in same Mon–Sun week
  const dates = rows.map(r => dayjs(r.filled_date));
  if (dates.some(d => !d.isValid())) return false;

  const minDate = dayjs.min(dates);
  const maxDate = dayjs.max(dates);

  // Monday start of week
  const startOfWeek = minDate.startOf("week").add(1, "day"); // Monday
  const endOfWeek = startOfWeek.add(6, "day");               // Sunday

  return dates.every(d =>
    d.isSameOrAfter(startOfWeek, "day") &&
    d.isSameOrBefore(endOfWeek, "day")
  );
};


  // Update merge button visibility whenever selection changes
  useEffect(() => {
    const selected = filteredData.filter(r => selectedRows.includes(r.id));
    setShowMergeBtn(validateWDSSelection(selected));
  }, [selectedRows, filteredData]);

  // Handle checkbox toggle
  const handleCheckboxChange = (rowId) => {
    setSelectedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter(id => id !== rowId)
        : [...prev, rowId]
    );
  };
const getDateRange = (dates) => {
  const dayjsDates = dates.map(d => dayjs(d));

  const minDate = dayjs.min(dayjsDates);
  const maxDate = dayjs.max(dayjsDates);

  return `${minDate.format("YYYY-MM-DD")} - ${maxDate.format("YYYY-MM-DD")}`;
};

   const resetSelection = () => {
    setSelectedRows([]);
    setShowMergeBtn(false);
  };
  const MergeForms=async()=>{
    setLoader(true)
    try {
    const selectedObjs = filteredData.filter(r => selectedRows.includes(r.id));
    const dates = selectedObjs.map(r => r.filled_date);
    console.log(dates)
    const range = getDateRange(dates);
    let data = [
      ...selectedObjs,
      { type: 'WDSMERGE' },
      { Dates: range }
    ];
 
const response = await api.post('/v1/forms/create-form', {
        emp_id: selectedObjs[0].emp_id,
        emp_name: selectedObjs[0].emp_name,
        companyid:selectedObjs[0].companyid,
        form_type: "WDS",
        job_id: selectedObjs[0].job_id,
        job_description:selectedObjs[0].jobDescription,
        observer_name:selectedObjs[0].emp_name,
        filled_date:selectedObjs[0].filled_date,
        json_data: data,
        documents: "",
        method:selectedObjs[0].method
      });
  
  if (response.status === 200) {
        setOpen(true);
        setSeverity("success");
        setAlertMessage('Forms Merged Successfully');
        fetchTablesData()
      
      }else{
         setSeverity("error");
      setAlertMessage('Something went wrong');
      setOpen(true);
      }

      
    } catch (error) {
  setSeverity("error");
      setAlertMessage('Something went wrong');
      setOpen(true);
      console.log("Submission error:", error);
    }finally{
      resetSelection()
setLoader(false)
    }
  }
 const handleSignOff = async (row,pmid) => {
  try {
    console.log("User Details:", userDetails);
setLoader(true)
    // ✅ Step 1: Check for signature_picture in user_info
    if (!userDetails?.user_info?.signature_picture) {
      setSeverity("error");
      setAlertMessage("Please update your signature before sign off.");
      setOpen(true);
      return; // Stop further execution
    }

const response =await api.post(`/v1/forms/${row.id}/update-pm-sign`,{
pm_id:pmid
  // "pm_sign": userDetails?.user_info?.signature_picture,

  // "pm_status": "Y"

})

if(response.status==200){
  setSeverity('success')
  setAlertMessage(response?.message||'Form Signed-off')
  setOpen(true)
  fetchTablesData()
   handleViewForm (row.id,row.form_type)
}else{
  setSeverity('info')
  setAlertMessage(response?.message||'Something went wrong')
  setOpen(true)
}
  } catch (error) {
    console.error("Sign off error:", error);
    setSeverity("error");
    setAlertMessage("Something went wrong during sign off.");
    setOpen(true);
  }finally{
    setLoader(false)
  }
};
const fetchOcrImage = async (fileName) => {
  try {
setLoading(true)
    // Call API
    const res = await api.get(
      `/v1/documents/view-multiple?filenames=${encodeURIComponent(fileName)}`
    );


    if (res.status === 200) {
      const imageUrl = res.data?.images?.[0] || res.images?.[0] || null;
      if (imageUrl) {
        console.log("🖼️ Client Observation Image URL:", imageUrl);
        setOcrimg(imageUrl)
        setOpenImgModal(true)
        return imageUrl;
      } else {
        console.warn("⚠️ No image URL found in response.");
        return null;
      }
    } else {
      console.warn("⚠️ Non-200 API status:", res.status);
      return null;
    }
  } catch (error) {
    console.error("❌ Error fetching Client Observation image:", error);
    return null;
  }finally{
    setLoading(false)
  }
};
useEffect(() => {
  setCurrentPage(1);
}, [selectedFilters]);
// const getRowDate = (row) => {
//   const dateFromJson = row.json_data?.find(obj => obj.Dates)?.Dates;

//   // If date range exists → take start date
//   const normalizedDate =
//     typeof dateFromJson === "string" && dateFromJson.includes(" - ")
//       ? dateFromJson.split(" - ")[0]
//       : dateFromJson;

//   return dayjs(normalizedDate || row.filled_date);
// };
const getRowDate = (row) => {
  const dateFromJson = row.json_data?.find(obj => obj.Dates)?.Dates;

  const normalizedDate =
    typeof dateFromJson === "string" && dateFromJson.includes(" - ")
      ? dateFromJson.split(" - ")[0]
      : dateFromJson;

  // created_at is UTC → convert to local
  if (row.created_at) {
    return dayjs.utc(row.created_at).local();
  }

  return dayjs(normalizedDate || row.filled_date);
};


const totalPages = Math.ceil(filteredData.length / rowsPerPage);

// const paginatedData = filteredData.slice(
//   (currentPage - 1) * rowsPerPage,
//   currentPage * rowsPerPage
// );
const sortedData = [...filteredData].sort(
  (a, b) => getRowDate(b).valueOf() - getRowDate(a).valueOf()
);

const paginatedData = sortedData.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);


  return (
    <SideNavLayout>
        <div className='flex flex-col min-h-[90vh] max-h-[90vh] p-2 overflow-y-auto ' style={{scrollbarWidth:"none"}}>
      <div className='font-inter font-bold text-[24px]'>
        Forms Dashboard
      </div>

    
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 w-full px-2">
            {/* When user clicks this div, BBS forms are shown */}
          <Bsshome token={token}/>
          <SafetyhHome  token={token}/>
          <Weeklydrivehome  token={token}/>
          <AccidentInvestigation token={token}/>
          <TrailerHome token={token}/>
        </div>
        <div className='flex justify-between gap-2 items-center mt-4'>
            <div className="relative flex-1 max-w-sm mr-auto">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search employee, job, form, observer, method..."
                className="w-full border-2 border-[#E4E4E7] rounded-md px-3 py-2 bg-white text-sm text-black focus:outline-none focus:border-[#8B1818]"
              />
              {searchTerm && (
                <button
                  type="button"
                  onClick={() => setSearchTerm("")}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-sm"
                  aria-label="Clear search"
                >
                  ✕
                </button>
              )}
            </div>
             <div className="relative" ref={pickerRef}>
                        <button
                          onClick={() => setShowPicker(!showPicker)}
                          className="flex items-center gap-2 border-2 border-[#E4E4E7] rounded-md px-3 py-2 bg-white text-sm text-black"
                        >
                          {calendericonblack}
                          <span>
                            {historyCalendar
                              ? `${dayjs(historyCalendar[0].startDate).format(
                                  "MMM D, YYYY"
                                )} - ${dayjs(historyCalendar[0].endDate).format(
                                  "MMM D, YYYY"
                                )}`
                              : "Select Date"}
                          </span>
                        </button>
          
                        {showPicker && (
                          <div className="absolute right-0 mt-2 z-[9999] shadow-lg border rounded-md bg-white">
                            <DateRangePicker
                              onChange={(item) => setSelectionRange([item.selection])}
                              ranges={selectionRange}
                              moveRangeOnFirstSelection={false}
                              maxDate={new Date()}
                            />
          
                            <div className="flex justify-end gap-2 p-3 border-t bg-gray-50">
                              <button
                                onClick={handleReset}
                                className="px-3 py-1 text-sm border rounded-md text-gray-600 hover:bg-gray-100"
                              >
                                Reset
                              </button>
                              <button
                                onClick={handleApply}
                                className="px-3 py-1 text-sm rounded-md bg-[#8B1818] text-white hover:bg-[#701313]"
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
          {/* Filter Button */}
          <div className="relative" ref={filterRef}>
            {/* <button
              onClick={() => setShowFilterPopup(!showFilterPopup)}
              className="flex items-center gap-2 border-2 border-[#E4E4E7] rounded-md px-3 py-2 bg-white text-sm text-black hover:bg-gray-50"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
              </svg>
              <span>Filters</span>
              {activeFilterCount > 0 && (
                <span className="bg-[#8B1818] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {activeFilterCount}
                </span>
              )}
            </button> */}

            {showFilterPopup && (
              <div className="absolute right-0 mt-2 z-[9999] shadow-xl border border-gray-200 rounded-xl bg-white w-[340px] overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between px-5 py-3 bg-gray-50 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                    </svg>
                    <span className="text-sm font-semibold text-gray-800">Filters</span>
                  </div>
                  {activeFilterCount > 0 && (
                    <button onClick={clearAllFilters} className="text-xs font-medium text-[#8B1818] hover:underline">
                      Clear All ({activeFilterCount})
                    </button>
                  )}
                </div>

                <div className="max-h-[380px] overflow-y-auto px-5 py-4 space-y-5" style={{ scrollbarWidth: "thin" }}>
                  {/* Company */}
                  {filterOptions.companyIds.length > 0 && (
                    <div>
                      <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-2">Company</p>
                      <div className="space-y-1">
                        {filterOptions.companyIds.map(c => {
                          const active = selectedFilters.companyIds.includes(c);
                          return (
                            <label
                              key={c}
                              className={`flex items-center gap-2.5 text-sm cursor-pointer px-3 py-2 rounded-lg transition-all ${
                                active ? "bg-[#8B1818]/5 border border-[#8B1818]/20" : "hover:bg-gray-50 border border-transparent"
                              }`}
                            >
                              <input
                                type="checkbox"
                                checked={active}
                                onChange={() => toggleFilter("companyIds", c)}
                                className="accent-[#8B1818] w-4 h-4 rounded"
                              />
                              <span className={`text-sm text-left ${active ? "font-medium text-gray-900" : "text-gray-600"}`}>
                                {companyMap[c] || `Company #${c}`}
                              </span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {filterOptions.companyIds.length > 0 && <div className="border-t border-gray-100" />}

                  {/* Form Name */}
                  <div>
                    <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-2">Form Name</p>
                    <div className="flex flex-col gap-2">
                      {filterOptions.formTypes.map(ft => {
                        const active = selectedFilters.formTypes.includes(ft);
                        return (
                          <button
                            key={ft}
                            onClick={() => toggleFilter("formTypes", ft)}
                            className={`text-left px-3 py-2 rounded-lg text-xs font-medium border transition-all ${
                              active
                                ? "bg-[#8B1818] text-white border-[#8B1818] shadow-sm"
                                : "bg-white text-gray-600 border-gray-200 hover:border-gray-400 hover:bg-gray-50"
                            }`}
                          >
                            {formTypeLabelMap[ft] || ft}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="border-t border-gray-100" />

                  {/* Method */}
                  <div>
                    <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-2">Method</p>
                    <div className="flex flex-wrap gap-2">
                      {filterOptions.methods.map(m => {
                        const active = selectedFilters.methods.includes(m);
                        return (
                          <button
                            key={m}
                            onClick={() => toggleFilter("methods", m)}
                            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${
                              active
                                ? "bg-[#8B1818] text-white border-[#8B1818] shadow-sm"
                                : "bg-white text-gray-600 border-gray-200 hover:border-gray-400 hover:bg-gray-50"
                            }`}
                          >
                            {m}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="border-t border-gray-100" />

                  {/* Status */}
                  <div>
                    <p className="text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-2">Status</p>
                    <div className="flex flex-wrap gap-2">
                      {filterOptions.displayStatuses.map(s => {
                        const active = selectedFilters.statuses.includes(s);
                        const colorClass = active
                          ? "bg-[#8B1818] text-white border-[#8B1818] shadow-sm"
                          : s === "Completed"
                            ? "bg-green-50 text-green-700 border-green-200 hover:border-green-400"
                            : s === "Signed"
                              ? "bg-blue-50 text-blue-700 border-blue-200 hover:border-blue-400"
                              : "bg-yellow-50 text-yellow-700 border-yellow-200 hover:border-yellow-400";
                        return (
                          <button
                            key={s}
                            onClick={() => toggleFilter("statuses", s)}
                            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${colorClass}`}
                          >
                            {s}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                </div>

                {/* Footer */}
                <div className="flex justify-end px-5 py-3 border-t border-gray-200 bg-gray-50">
                  <button
                    onClick={() => setShowFilterPopup(false)}
                    className="px-4 py-1.5 text-sm font-medium rounded-lg bg-[#8B1818] text-white hover:bg-[#701313] transition-colors shadow-sm"
                  >
                    Apply
                  </button>
                </div>
              </div>
            )}
          </div>

          {showMergeBtn&&selectedRows?.length>1 && (
          <button
            className="bg-black text-white px-4 py-2 rounded  w-fit"
            onClick={() => {
              MergeForms()
              // const selected = filteredData.filter(r => selectedRows.includes(r.id));
              // console.log(selected)
              // // open modal for merging
              // setRowData(selected);
              // setFormType("WDS");
              // setFormView(true);
            }}
          >
            Merge Forms
          </button>
        )}
        </div>
     <div>
      
     <div className="mt-2 mb-6">
  <div className="overflow-x-auto rounded-xl shadow-md ">
    <table className=" w-full bg-white text-left rounded-xl  ">
      <thead className="bg-[#E4E4E7] text-[#6B7280] font-Font1  text-xs  uppercase">
      <tr>
        {/* <th className="px-2 py-3"></th> */}
  <th className="px-2  font-inter text-center py-3">
    
    <div   onClick={() => setActiveModal('date')} className="flex items-center  justify-center cursor-pointer">
      Date <KeyboardArrowDownIcon />
    </div>
  </th>
  <th className="px-2 py-3">
    <div onClick={() => setActiveModal('employee')} className="flex items-center cursor-pointer">
      Employee <KeyboardArrowDownIcon />
    </div>
  </th>
  <th className="px-2 py-3">
    <div onClick={() => setActiveModal('job')} className="flex  items-center  cursor-pointer">
      Job <KeyboardArrowDownIcon />
    </div>
  </th>
  <th className="px-2 py-3">
    <div onClick={() => setActiveModal('form')} className="flex w-[18%] items-center  cursor-pointer">
      Formname <KeyboardArrowDownIcon />
    </div>
  </th>
  <th className="px-2 py-3">
    <div onClick={() => setActiveModal('method')} className="flex items-center cursor-pointer">
      Method <KeyboardArrowDownIcon />
    </div>
  </th>
  <th className="px-2 py-3">
    <div className="flex items-center cursor-pointer">
      Observer <KeyboardArrowDownIcon />
    </div>
  </th>
  <th className="px-2 py-3">
    <div onClick={() => setActiveModal('status')} className="flex items-center cursor-pointer">
      Status <KeyboardArrowDownIcon />
    </div>
  </th>
  <th className="px-2 py-3">
    <div className="flex items-center cursor-pointer">
      Action <KeyboardArrowDownIcon />
    </div>
  </th>
</tr>

      </thead>
      <tbody className="text-[#374151] text-sm ">
      {paginatedData.length > 0 ? (
    [...paginatedData].map((row, id) => (
            <tr key={id} className="border-t">
                 {/* <td className="px-2 text-center">
                    {row.form_type === 'WDS' && !row.json_data?.some(obj => obj.Dates) && (
  <input
    type="checkbox"
    className="cursor-pointer"
    checked={selectedRows.includes(row.id)}
    onChange={() => handleCheckboxChange(row.id)}
  />
)}

                    </td> */}
     <td className="px-2 font-inter text-center py-4 w-[14%]">
  {(() => {
    const rawDate =
      row.json_data?.find(obj => obj.Dates)?.Dates ||
      row.filled_date;

    if (!rawDate) return "";

    if (rawDate.includes(" - ")) {
      const [start, end] = rawDate.split(" - ");
      return `${dayjs(start).format("MM-DD-YYYY")} - ${dayjs(end).format("MM-DD-YYYY")}`;
    }

    return dayjs(rawDate).format("MM-DD-YYYY");
  })()}
</td>

             <td className="px-2 font-inter py-4">
  {row.emp_name && row.emp_id
    ? `${row.emp_name} (${row.emp_id})`
    : "-"}
</td>

           <td className="px-2 text-xs font-inter py-2 w-[15%] whitespace-normal break-words">
  {row.jobDescription}
  {row.job_id && row.job_id !== "0" && row.job_id !== 0 ? ` (${row.job_id})` : " -"}
</td>


              <td className="px-1 text-xs font-inter py-4 w-[18%]">
  {row.form_type === 'BBS'
    ? 'BEHAVIOR BASED SAFETY (BBS) CARD'
    : row.form_type === 'SHP'
    ? 'SAFETY AND HEALTH PRIMARY AUDIT FORM'
    : row.form_type === 'WDS'
    ? 'WEEKLY DRIVER LOG & SAFETY'
    : row.form_type === 'TRAILER'
    ? 'TRAILER INSPECTION FORM'
    : row.form_type}
</td>
<td className="px-1 pr-6 font-inter text-center py-4">
  {row.method ? row.method : '-'}
</td>


              <td className="px-2 font-inter py-4 w-[10%]">{row.observer_name}</td>
              <td className="px-2 font-inter py-4 text-left">
              <span className="text-green-600 text-lg">
  {userDetails.role === 3&&row.form_type=== "SHP" ? (
    row.pm_status === 'Y' ? (
      <div className="flex gap-1 items-center">
        <div className="w-3 h-3 bg-green-600 rounded-full"></div>
        <p className="text-sm">Signed</p>
      </div>
    ) : (
      // <button
      //   className="bg-blue-600 text-white text-xs px-3 py-1 rounded-md hover:bg-blue-700"
      //   onClick={() => handleSignOff(row)}
      // >
      //   Sign Off
      // </button>
         <div className="flex gap-1 items-center">
        <div className="w-3 h-3 bg-yellow-600  rounded-full"></div>
        <p className="text-sm text-yellow-700">Pending</p>
      </div>
    )
  ) : (!row.pm_sign&&(row.form_type=== "SHP")&&row.pm_status== "N"? (
      <div className="flex gap-1 items-center">
        <div className="w-3 h-3 bg-yellow-600  rounded-full"></div>
        <p className="text-sm text-yellow-700">Pending</p>
      </div>
    ) :
    row.status === 'A' ? (
      <div className="flex gap-1 items-center">
        <div className="w-3 h-3 bg-green-600 rounded-full"></div>
        <p className="text-sm">Completed</p>
      </div>
    ) : (
      <div className="flex gap-1 items-center">
        <div className="w-3 h-4 bg-orange-600 rounded-full"></div>
        <p className="text-sm">Pending</p>
      </div>
    )
  )}
</span>

              </td>
              <td className="pl-8 items-center w-[15%] py-4 "><div className='flex gap-1 items-center'>


                  {( userDetails?.user_info?.permissions?.includes('A2'))&&<div disabled={
  row.json_data?.some(obj => obj.Dates) ||  (row.form_type === "SHP" && row?.pm_sign)
}
 onClick={()=>{
               if (row?.form_type === "BBS") {
  navigate(`/bbs-form?mode=edit&id=${row.id}`);
}else if((row?.form_type === "SHP"||row?.form_type === "SHPA")&&(!row?.pm_sign)) {
    navigate(`/safety-form?mode=edit&id=${row.id}`);

}if(row.form_type === 'WDS'||row.form_type === 'WDLS'){
      navigate(`/driver-form?mode=edit&id=${row.id}`);
}if(row.form_type === 'AIF'){
      navigate(`/accident-form?mode=edit&id=${row.id}`);
}if(row.form_type === 'TRAILER'){
      navigate(`/trailer-form?mode=edit&id=${row.id}`);
}

                }} className={
  `w-[38px] p-1 flex items-center justify-center rounded
    ${((row.form_type === 'BBS'||row.form_type === 'SHP'||row.form_type === 'SHPA'||row.form_type === 'WDS'||row.form_type === 'WDLS'||row.form_type === 'AIF'||row.form_type === 'TRAILER')&&(!row?.pm_sign))
      ? (
          row.json_data?.filter(obj => obj.Dates).length > 0
            ? "bg-gray-400 cursor-not-allowed opacity-60"   // BBS → disabled
            : "bg-[#1E4976] cursor-pointer hover:bg-blue-700 text-white"  // BBS → enabled
        )
      : "bg-gray-400 cursor-not-allowed opacity-60"  // Non-BBS → always disabled
    }`
  }>
                  <EditIcon style={{width:"20px"}}/>
                </div>}
                <div onClick={()=>{
                  // setFormView(true);
                  handleViewForm(row.id,row.form_type);
                  // setFormType(row.form_type);
                  console.log(row,'row')
                }} className="bg-[#1E4976] w-[38px] cursor-pointer text-white p-1 flex items-center justify-center rounded hover:bg-blue-700">
                  <RemoveRedEyeIcon style={{width:"20px"}}/>
                </div>
                <div
                  onClick={() => setDeleteConfirm(row)}
                  title="Delete form"
                  className="bg-red-600 w-[38px] cursor-pointer text-white p-1 flex items-center justify-center rounded hover:bg-red-700"
                >
                  <DeleteOutlineIcon style={{ width: "20px" }} />
                </div>
                {Array.isArray(row?.json_data) &&
 row.json_data.some(item => item?.capture_form_image?.file_name) && (
  <div
    onClick={() => {
 fetchOcrImage(row.json_data.find(item => item?.capture_form_image?.file_name)?.capture_form_image?.file_name);
    }}
    className="bg-[#1E4976] w-[38px] cursor-pointer text-white p-1 flex items-center justify-center rounded hover:bg-blue-700"
  >
    <ImageIcon style={{ width: "20px" }} />
  </div>
)}

              </div>
               
              </td>
            </tr>
          ))
        ) : (
          <tr className='w-full'>
            <td colSpan="6" className="px-6 py-4 text-center text-gray-700 text-sm w-full">
            <div className="flex  items-center ml-24 justify-center text-md gap-2">
    {/* <img src={noData} alt="No data" className="w-6 h-6" /> */}
    <span className='text-md font-inter'>No data found</span>
  </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
    <div className="flex items-center justify-between mt-4 px-2">
  {/* Rows per page */}
  <div className="flex items-center gap-2 text-sm py-2">
    <span>Rows per page:</span>
    <select
      value={rowsPerPage}
      onChange={(e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1);
      }}
      className="border rounded px-2 py-1"
    >
      {[10, 20, 50, 100].map(size => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
  </div>

  {/* Pagination buttons */}
<div className="flex items-center gap-3">
  <button
    className="p-2 border rounded disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100"
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(prev => prev - 1)}
  >
    <FontAwesomeIcon icon={faChevronLeft} />
  </button>

  <span className="text-sm">
    Page {currentPage} of {totalPages || 1}
  </span>

  <button
    className="p-2 border rounded disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100"
    disabled={currentPage === totalPages || totalPages === 0}
    onClick={() => setCurrentPage(prev => prev + 1)}
  >
    <FontAwesomeIcon icon={faChevronRight} />
  </button>
</div>

</div>

  </div>
      </div>

     </div>
   
     

     <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader||loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {formView && (
  <>
    {formType === 'BBS' && (
      <ViewFormModal
        formType={formType}
        rowData={rowData}
        setFormView={setFormView}
      />
    )}

 {formType === 'WDS' && (
  rowData?.json_data?.some(obj => obj.Dates) ? (
    <WDSMergeFormModal
      formType={formType}
      rowData={rowData}
      setFormView={setFormView}
    />
  ) : (
    <WDSFormModal
      formType={formType}
      rowData={rowData}
      setFormView={setFormView}
    />
  )
)}

    {formType === 'WDLS' && (
  <WDSFormModal
    formType={formType}
    rowData={rowData}
    setFormView={setFormView}
  />
)}
    {formType === 'SHP' && (
      <ViewSHPFormModal // Or another modal if needed for SHP
        formType={formType}
        rowData={rowData}
        setFormView={setFormView}
        handleSignOff={handleSignOff}
      />
    )}
    {formType === 'SHPA' && (
      <ViewSHPFormModal // Or another modal if needed for SHP
        formType={formType}
        rowData={rowData}
        setFormView={setFormView}
        handleSignOff={handleSignOff}
      />
    )}
    {formType === 'AIF' && (
        <AIFFormModal // Or another modal if needed for SHP
        formType={formType}
        rowData={rowData}
        formView={formView}
        setFormView={setFormView}
      />
    )
    }
    {formType === 'TRAILER' && (
      <ViewTrailerModal
        formType={formType}
        rowData={rowData}
        setFormView={setFormView}
      />
    )}
  </>
)}
            {activeModal === 'date' && (
 <FilterModal
  label="Date"
  dataList={[
    ...new Set(
      tableData.map((row) => {
        // look inside json_data for an object with "Dates"
        const dateObj = row.json_data?.find((obj) => obj.Dates);

        // if found, use its value, else fallback to filled_date
        return dateObj ? dateObj.Dates : row.filled_date;
      })
    ),
  ]}
  selectedValues={selectedFilters.dates}
  onSave={(values) =>
    setSelectedFilters((prev) => ({ ...prev, dates: values }))
  }
  onClose={() => setActiveModal(null)}
/>

)}

{activeModal === 'employee' && (
  <FilterModal
    label="Employee"
    dataList={[...new Set(tableData.map(row => `${row.emp_name} (${row.emp_id})`))]}
    selectedValues={selectedFilters.employees}
    onSave={(values) => setSelectedFilters(prev => ({ ...prev, employees: values }))}
    onClose={() => setActiveModal(null)}
  />
)}

{activeModal === 'job' && (
  <FilterModal
    label="Job"
    dataList={[...new Set(tableData.map(row => `${row.jobDescription} (${row.job_id})`))]}
    selectedValues={selectedFilters.jobs}
    onSave={(values) => setSelectedFilters(prev => ({ ...prev, jobs: values }))}
    onClose={() => setActiveModal(null)}
  />
)}

{activeModal === 'form' && (
  <FilterModal
    label="Filter Form Type"
    dataList={[...new Set(tableData.map(row => row.form_type))]}
    selectedValues={selectedFilters.formTypes}
    onSave={(values) => setSelectedFilters(prev => ({ ...prev, formTypes: values }))}
    onClose={() => setActiveModal(null)}
    labelMap={formTypeLabelMap}
  />
)}

{activeModal === 'method' && (
  <FilterModal
    label="Method"
    dataList={[...new Set(tableData.map(row => row.method))]}
    selectedValues={selectedFilters.methods}
    onSave={(values) => setSelectedFilters(prev => ({ ...prev, methods: values }))}
    onClose={() => setActiveModal(null)}
  />
)}


{activeModal === 'status' && (
  <FilterModal
    label="Status"
    dataList={[...new Set(tableData.map(r => getDisplayStatus(r)))]}
    selectedValues={selectedFilters.statuses}
    onSave={(values) => setSelectedFilters(prev => ({ ...prev, statuses: values }))}
    onClose={() => setActiveModal(null)}
  />
)}


      </div>
      {deleteConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] px-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Delete this form?</h3>
            <p className="text-sm text-gray-600">
              Are you sure you want to delete this {formTypeLabelMap[deleteConfirm.form_type] || deleteConfirm.form_type} form
              {deleteConfirm.emp_name ? ` filled by ${deleteConfirm.emp_name}` : ""}
              {deleteConfirm.filled_date ? ` on ${dayjs(deleteConfirm.filled_date).format("MM-DD-YYYY")}` : ""}
              ? 
            </p>
            <div className="flex justify-end gap-2 mt-5">
              <button
                onClick={() => setDeleteConfirm(null)}
                className="px-4 py-1.5 text-sm rounded-md border border-gray-200 hover:bg-gray-100 text-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={() => handleSoftDelete(deleteConfirm)}
                className="px-4 py-1.5 text-sm rounded-md bg-red-600 text-white hover:bg-red-700 font-medium"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <OcrImageModal
  isOpen={openImgModal}
  onClose={() => setOpenImgModal(false)}
  imgSrc={ocrimg?.base64_data}
/>

        <ToastMessage message={alertMessage} severity={severity} open={open} handleClose={handleCloseToast} />
      </SideNavLayout>
  );
};

export default FormsDashboard;
